import { useEffect, useRef, useState } from 'react'
import { Dir, SubDir } from '../../interface'
import {
  CloseIcon,
  CloseWrapper,
  MenuIcon,
  TabItem,
  TabMask,
  TabMaskWrapper,
  TabWrapper,
  Wrapper,
} from './atoms'
import { useLocation } from '@reach/router'
import { Menu } from './svg/menu'
import { Close } from './svg/close'
import { Catalogue, CatalogueDrawer } from '../catalogue'

interface Props {
  dirs: Dir[]
  firstSubDirs: SubDir | null
  currentSlug: string
  rootSlug: string
}

export const Tab = ({ dirs, firstSubDirs, currentSlug, rootSlug }: Props) => {
  const { pathname } = useLocation()
  const [showTopBanner, setShowTopBanner] = useState(false)
  const [showDrawer, setShowDrawer] = useState(false)
  const tabRef = useRef<HTMLDivElement | null>(null)
  const [hideMask, setHideMask] = useState({ left: true, right: false })

  const handleStorageChange = () => {
    setShowTopBanner(sessionStorage.getItem('fox_top_hide') !== '1')
  }

  const handleScrollTab = () => {
    if (tabRef.current) {
      setHideMask({
        left: tabRef.current.scrollLeft === 0,
        right:
          tabRef.current.scrollWidth - tabRef.current.clientWidth < tabRef.current.scrollLeft + 1, // + 1 因为移动端采用 vw，增加容错
      })
    }
  }

  useEffect(() => {
    const tabRefCurrent = tabRef.current
    handleScrollTab()
    handleStorageChange()
    window.addEventListener('storage', handleStorageChange)
    tabRefCurrent && tabRefCurrent.addEventListener('scroll', handleScrollTab)
    return () => {
      window.removeEventListener('storage', handleStorageChange)
      tabRefCurrent && tabRefCurrent.removeEventListener('scroll', handleScrollTab)
    }
  }, [])

  useEffect(() => {
    const target = document.getElementById(rootSlug)
    if (target && tabRef.current) {
      tabRef.current.scrollTo({ left: target.offsetLeft - 100 })
    }
  }, [rootSlug])

  return (
    <Wrapper $showTopBanner={showTopBanner}>
      <MenuIcon onClick={() => setShowDrawer(true)}>
        <Menu />
      </MenuIcon>
      <TabWrapper ref={tabRef}>
        {dirs.map((item) => (
          <TabItem
            id={item.slug}
            key={item.id}
            to={`/support/${item.slug}`}
            $isActive={pathname.includes(item.slug)}
          >
            {item.name}
          </TabItem>
        ))}
      </TabWrapper>
      <TabMaskWrapper $width={tabRef.current?.offsetWidth || 0}>
        {!hideMask.left && <TabMask $type='left' />}
        {!hideMask.right && <TabMask $type='right' />}
      </TabMaskWrapper>
      <CatalogueDrawer visible={showDrawer} handleMaskClick={() => setShowDrawer(false)}>
        <CloseWrapper>
          <CloseIcon onClick={() => setShowDrawer(false)}>
            <Close />
          </CloseIcon>
        </CloseWrapper>
        <Catalogue firstSubDirs={firstSubDirs} currentSlug={currentSlug} rootSlug={rootSlug} />
      </CatalogueDrawer>
    </Wrapper>
  )
}
